/* eslint-disable react/require-default-props */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SvgIcon = forwardRef((props, ref) => {
  const {
    children,
    className,
    color = 'current',
    size = 'regular',
    ...other
  } = props;

  const classes = classNames('sui-inline-block sui-align-baseline sui-h-[1em] sui-w-[1em]', {
    'sui-fill-current': color === 'current',
    'sui-fill-primary': color === 'primary',
    'sui-fill-inverse': color === 'inverse',
    'sui-fill-subtle': color === 'subtle',
    'sui-fill-medium': color === 'medium',
    'sui-fill-success': color === 'success',
    'sui-fill-warning': color === 'warning',
    'sui-fill-danger': color === 'danger',
    'sui-fill-info': color === 'info',
    'sui-text-base': size === 'small', // 16px
    'sui-text-3xl': size === 'regular', // 24px
    'sui-text-6xl': size === 'large', // 32px
  }, className);

  return (
    <svg
      className={classes}
      ref={ref}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      {...other}
    >
      {children}
    </svg>
  );
});

SvgIcon.displayName = 'SvgIcon';

SvgIcon.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.oneOf(['primary', 'inverse', 'inactive', 'success', 'danger', 'medium', 'warning', 'info', 'current']),
  size: PropTypes.oneOf(['small', 'regular', 'large', 'inherit'])
};

SvgIcon.defaultProps = {
};

export { SvgIcon };